/**
 * * Модель добавления наблюдателей к задаче
 */
export default class ObserverUpdateRequest  {
	/**
	 * * Номера пользователей
	 */
	UsersId!: Array<number>;
	/**
	 * * Номер задачи
	 */
	TaskId!: number;
	constructor(obj?: Partial<ObserverUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
